var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKinLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 476.44 506.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #91c6af;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m415,236.23V70.4c0-.81-.66-1.47-1.47-1.47,0,0-3.1-.03-8.54-.08h-173.94c-11.37.26-19.63.68-21.99,1.24-36.5,5.13-69.26,22.19-96.63,49.57-65.65,65.65-69.03,169.95-10.23,239.63.43.51.47,1.25.08,1.79l-29.85,41.85,62.69,50.4,33.05-43.92c.4-.55,1.12-.75,1.74-.49,21.7,8.99,44.81,13.52,67.94,13.52,45.39,0,90.79-17.32,125.42-51.95,27.81-27.81,44.43-62.55,49.91-98.66,0-.04.01-.08.01-.12.1-1.46,2.09-29.74,1.8-35.49Zm-68.76,27.75c0,.06-.01.11-.02.17-3.89,22.34-14.42,42.61-30.56,58.74-20.78,20.78-48.42,32.23-77.81,32.23-8.68,0-17.21-1.01-25.45-2.96-1.02-.24-1.45-1.45-.84-2.3l69.27-95.06c.49-.67.33-1.61-.35-2.08l-66.47-45.78c-.66-.45-1.56-.3-2.03.36l-66.65,93.42c-.62.86-1.93.82-2.46-.1-24.64-42.14-18.93-97.26,17.16-133.36,15.16-15.16,34.03-25.39,54.85-29.78,1.9-.4,6.48-1.16,8.42-1.23.75-.03,1.62-.05,2.57-.07h99.16c10.24.05,18.02.09,21.16.08.81,0,1.47.66,1.47,1.47l.02,100.54c-.09,3.87-.71,14.97-1.45,25.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinLeaf);
export default __webpack_public_path__ + "static/media/Kin-leaf.aa3bdd67a82713462bfd9753408ab9e8.svg";
export { ForwardRef as ReactComponent };